'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lite = require('algoliasearch/lite');

var _lite2 = _interopRequireDefault(_lite);

var _reactInstantsearchCore = require('react-instantsearch-core');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var InstantSearch = (0, _reactInstantsearchCore.createInstantSearch)(_lite2.default, {
  Root: 'div',
  props: {
    className: 'ais-InstantSearch__root'
  }
});

exports.default = InstantSearch;


//////////////////
// WEBPACK FOOTER
// ./~/react-instantsearch-dom/dist/cjs/widgets/InstantSearch.js
// module id = 1081
// module chunks = 142807904292071